<template>
  <div style="min-height: 100vh; overflow-y: scroll">
    <div v-if="showMask" class="mask" @click="closeMask"></div>
    <div
      v-if="showMask"
      class="special"
      style="background-image: url('img/luckyCoin/special_tips.png')"
    >
      <div class="text_box">
        <div
          class="tip_text"
          style="background-image: url('img/luckyCoin/special_text.png')"
        ></div>
      </div>
    </div>
    <div
      class="top_bg"
      style="background-image: url('img/luckyCoin/top_bg.png')"
    >
      <div
        class="back_btn"
        style="background-image: url('img/cpRank/back_btn.png')"
        @click="closePage"
      ></div>
      <div
        class="tips"
        style="background-image: url('img/magicPlace/tips.png')"
        @click="showMask = true"
      ></div>
       <div
        class="rank"
        style="background-image: url('img/luckyCoin/rank_btn.png')"
        @click="toRank"
      ></div>
      <!-- <back-nav :icon="'img/backw.png'" :textColor="'#fff'" :backColor="'none'" /> -->

      <div
        class="notice"
        @click="toRank"
        style="background-image: url('img/luckyCoin/notice_bg.png')"
        v-if="giftArr.length > 0"
      >
        <van-swipe :autoplay="2000" :height="27" :vertical="true">
          <van-swipe-item v-for="(item, index) in giftArr" :key="index">
            <template>
              恭喜<span class="nick_name">{{ item.nickname }}</span
              >在<span class="gold_name">圣境之塔</span>中获得了<span
                class="gift_name_"
                >{{ item.diamonds }}</span
              >
               <span class="gold_name">金币</span>
            </template>
          </van-swipe-item>
        </van-swipe>
      </div>

      <div
        class="bronze_bag one_bag"
        style="background-image: url('img/luckyCoin/egg_bg_1.png')"
      >
        <!-- <div class="bag_title" style="background-image: url('img/magicPlace/title_1.png')"></div> -->
        <!-- <div class="rate" v-if="level3.length>0" style="background-image: url('img/magicPlace/rate3.png');">{{'中奖率:'+level3[0].rate+'%'}}</div> -->
        <div class="gift_box">
          <div
            v-for="(item, index) in info"
            :key="index"
            class="gift_content"
            style="background-image: url('img/luckyCoin/gift_bg.png')"
          >
            <img v-if="item.diamonds==1" class="coin" src="img/luckyCoin/1_coin.png" alt="" />
            <img v-if="item.diamonds==10" class="coin" src="img/luckyCoin/10_coin.png" alt="" />
            <img v-if="item.diamonds==100" class="coin" src="img/luckyCoin/100_coin.png" alt="" />
            <img v-if="item.diamonds==1000" class="coin" src="img/luckyCoin/1000_coin.png" alt="" />
            <img v-if="item.diamonds==10000" class="coin" src="img/luckyCoin/10000_coin.png" alt="" />
            <img v-if="item.diamonds==100000" class="coin" src="img/luckyCoin/100000_coin.png" alt="" />
            <span class="value">{{ item.diamonds }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import "@/assets/css/luckyCoin.css";
import { luckyGiftDetail, serverPullMsg } from "@/api/api";
export default {
  data() {
    return {
      info: [],
      listData: [],
      rankCur: 0,
      room_id: "",
      showMask: false,
      giftArr: [],
      showNotice: false,
      params: {
        type: 3,
        page: 1,
        rows: 15,
        gift_id:1
      },
    };
  },
  created() {
    let access_token = this.$route.query.access_token;
    localStorage.setItem("access_token", access_token);
    this.room_id = this.$route.query.room_id;
    this.getInfo();
    this.getRank();
  },
  methods: {
    getInfo() {
      let params = {};
      luckyGiftDetail(params).then((res) => {
        this.info = res.data[0].gift_info;
      });
    },
    getRank() {
      serverPullMsg(this.params)
        .then(
          (res) => {
            this.giftArr = res.data;
            console.log(this.giftArr);
          },
          (error) => {
            this.$toast.fail(error);
          }
        )
        .catch((error) => {
          this.$toast.fail(error);
        });
    },
    closeMask() {
      this.showMask = false;
    },
    toRank() {
      this.$router.push({ path: "/luckyCoinRank?type=3" });
    },
    closePage() {
      let params = "调用";
      this.$bridge.callhandler("closePage", params, (data) => {
        // 处理返回数据
      });
    },
  },
};
</script>
   